var _desc, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.80957,
    height: 19.237305,
    viewBox: "0 0 17.8096 19.2373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.33 4.61L17.47 4.61",
    stroke: "#49498A",
    strokeOpacity: 0.66,
    strokeWidth: 0.666666,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.33 4.61L15.33 17.47C15.33 17.85 15.18 18.21 14.91 18.48C14.64 18.75 14.28 18.9 13.9 18.9L3.9 18.9C3.52 18.9 3.16 18.75 2.89 18.48C2.62 18.21 2.47 17.85 2.47 17.47L2.47 4.61L15.33 4.61Z",
    stroke: "#49498A",
    strokeOpacity: 0.66,
    strokeWidth: 0.666666,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33 4.61L5.33 3.9C5.33 2.95 5.7 2.04 6.37 1.37C7.04 0.7 7.95 0.33 8.9 0.33C9.85 0.33 10.75 0.7 11.42 1.37C12.09 2.04 12.47 2.95 12.47 3.9L12.47 4.61",
    stroke: "#49498A",
    strokeOpacity: 0.66,
    strokeWidth: 0.666666,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.76 7.47L6.76 15.33",
    stroke: "#49498A",
    strokeOpacity: 0.66,
    strokeWidth: 0.666666,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.04 7.47L11.04 15.33",
    stroke: "#49498A",
    strokeOpacity: 0.66,
    strokeWidth: 0.666666,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.aedd26cf6404765bda52057b2143c257.svg";
export { ForwardRef as ReactComponent };